"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _tag = require("../styles/tag"),
    _Icon = _interopRequireDefault(require("../../Icon"));

function Tag(a) {
  var b = a.onClick,
      c = a.tagName,
      d = a.className,
      e = a.disabled,
      f = a.valid;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("tag", _tag.TAG, d, (0, _defineProperty2["default"])({
      tag__disabled: e
    }, _tag.DISABLED_TAG, e), (0, _defineProperty2["default"])({
      tag__invalid: !f
    }, _tag.INVALID_TAG, !f))
  }, _react["default"].createElement("p", {
    className: "tag__text"
  }, c), e ? null : _react["default"].createElement(_Icon["default"], {
    onClick: b,
    className: (0, _classnames["default"])(_tag.ICON),
    name: "close",
    size: 10,
    color: "parthenon"
  }));
}

var _default = (0, _react.memo)(Tag);

exports["default"] = _default;